import { createCookie, deleteCookie, getCookie } from './cookie'

export function getStorage(key: string | undefined): string | boolean {
  if (!key) return false
  return getCookie(key)
}

export function setStorage(key: string, value: any): boolean {
  if (!key && !value) return false
  return createCookie({ key, value })
}

export function deleteStorage(key: string | undefined): boolean {
  if (!key) return false
  return deleteCookie(key)
}
